
export enum UnassignPickupsSourceCd {
	PAST_DUE = 'PastDue',
	UNASSIGNED = 'Unassigned',
	UNMAPPED = 'Unmapped'}
